// extracted by mini-css-extract-plugin
export default {"routineParametersForm":"routineParametersForm-cOg0W"};